// extracted by mini-css-extract-plugin
export default {"container":"hZ-z","heading":"iZ-z","links":"jZ-z","copy":"kZ-z","subCopy":"lZ-z","linksLeft":"mZ-z","linksCenter":"nZ-z","linksRight":"oZ-z","link":"pZ-z","onlyLink":"qZ-z"};